import dayjs from "dayjs";

const format = (date = Date.now(), _format = "YYYY-MM-DD") => {
  return dayjs(date).format(_format);
};

const formatDate = (date) => {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  return [year, month, day].map(formatNumber).join("-");
};

const formatNumber = (n) => {
  n = n.toString();
  return n[1] ? n : "0" + n;
};

export default {
  format,
  formatDate,
};
